export default __webpack_public_path__ + "static/media/item_1.d4f48868.webp";